import styled from 'styled-components'

import dimensions from 'shared/styles/dimensions'
import { colors } from 'shared/styles/colors'

export const Subtitle = styled.div`
  width: 100%;
  font-weight: bold;
  font-size: 18;
  padding-top: 1rem;
  color: ${colors.white};
`

export const ItemValidationPassword = styled.div<{ is_valid: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  color: ${colors.white};
  margin-top: ${dimensions.spaces.small}px;
  svg {
    color: ${colors.primary};
    margin-right: 0.5rem;

    background-color: ${p => (p.is_valid ? colors.green : colors.red)};
    border-radius: 50%;

    align-items: center;
    justify-content: center;

    height: 16px;
    width: 16px;
  }
`
